import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AdminUnlicensed from "@/components/AdminUnlicensed";
import AdminSubscriptionBlocked from "@/components/AdminSubscriptionBlocked";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="text-sm tracking-widest text-gray-400 uppercase">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === "superadmin") return <Navigate to="/super" replace />;
  if (user.role === "asistencia") return <Navigate to="/admin/login" replace />;
  if (user.role === "admin" && user.admin_licensed === false) return <AdminUnlicensed />;
  if (
    user.role === "admin" &&
    user.subscription?.access_blocked &&
    !location.pathname.startsWith("/admin/suscripcion")
  ) {
    return <AdminSubscriptionBlocked />;
  }
  return children;
}
